import React from "react";
import { Helmet } from "react-helmet-async";
import Navbar from "../Components/Navbar/Navbar";
import ProductCard from "../Components/ProductCard/ProductCard";
import Footer from "../Components/Footer/Footer";
import { Box } from "@mui/material";
import CardImg from "../Assets/almond_croissant.png";
import useMetaTracking from "../hooks/useMetaTracking";

function AlmondCroissant() {
  useMetaTracking("ViewContent", {
    content_name: "Almond Croissant",
    content_category: "Pastries",
    content_ids: ["almond_croissant"],
    content_type: "pastries",
    value: 3.75,
    currency: "USD",
  });

  const pageTitle = "Almond Croissant | Đông Hưng Viên Bakery";
  const pageDescription =
    "A crisp, golden croissant with a soft almond-filled center that makes every bite rich, nutty, and deeply satisfying.";

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:image" content={CardImg} />
      </Helmet>

      <Box className="product-page" sx={{ pt: 10, background: "#0f0f0f", color: "#fff" }}>
        <Navbar />
        <ProductCard
          cardImg={CardImg}
          titleHead="Almond Croissant"
          titleSubHead="$3.75 each"
          detailBody="A crisp, golden croissant with a soft almond-filled center that makes every bite rich, nutty, and deeply satisfying."
          detailBodyBr="Contains: wheat, dairy, almond, sesame"
          ProductCardBtn="View Full Regular Menu"
          btnLink="/regular-menu"
        />
        <Footer />
      </Box>
    </>
  );
}

export default AlmondCroissant;